import { render, staticRenderFns } from "./privateFund.vue?vue&type=template&id=3253165b"
import script from "./privateFund.vue?vue&type=script&lang=js"
export * from "./privateFund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports